window.addEventListener('load', function() {
  var loadMoreNewsButton = document.querySelector('.js-load-more-news');
  if ( undefined != loadMoreNewsButton ) {
    var listNewsContainer = document.querySelector('.list-news__container');
    loadMoreNewsButton.addEventListener('click', function() {
      loadMoreNewsButton.classList.add('loading');

      // Ajax Call
      var xhr = new XMLHttpRequest();
      var loadNewsAjaxUrl =
        'action=load_more_news' +
        '&_wpnonce=' + loadMoreNewsButton.getAttribute('data-nonce') +
        '&offset=' + loadMoreNewsButton.getAttribute('data-offset') +
        '&load_more_type=' + loadMoreNewsButton.getAttribute('data-load-more-type') +
        '&load_more_value=' + loadMoreNewsButton.getAttribute('data-load-more-value')
      xhr.open('POST', ecom_js.ajaxurl, true);
      xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      xhr.onload = function() {
        if (xhr.status === 200) {
          var response = JSON.parse(xhr.response);

          listNewsContainer.innerHTML += response.output;

          loadMoreNewsButton.classList.remove('loading');
          loadMoreNewsButton.setAttribute('data-offset', response.offset);

          if ( !response.more_result ) {
            loadMoreNewsButton.classList.add('hide');
          }
        }
      };
      xhr.send(loadNewsAjaxUrl);
    });
  }

  var loadMoreEventsButton = document.querySelector('.js-load-more-events');
  if ( undefined != loadMoreEventsButton ) {
    var listEventsContainer = document.querySelector('.list-event__container');
    loadMoreEventsButton.addEventListener('click', function() {
      loadMoreEventsButton.classList.add('loading');

      // Ajax Call
      var xhr = new XMLHttpRequest();
      var loadNewsAjaxUrl =
        'action=load_more_events' +
        '&_wpnonce=' + loadMoreEventsButton.getAttribute('data-nonce') +
        '&next-month=' + loadMoreEventsButton.getAttribute('data-next-month')
      xhr.open('POST', ecom_js.ajaxurl, true);
      xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      xhr.onload = function() {
        if (xhr.status === 200) {
          var response = JSON.parse(xhr.response);

          listEventsContainer.innerHTML += response.output;
          loadMoreEventsButton.setAttribute('data-next-month', response.nextMonth);

          loadMoreEventsButton.classList.remove('loading');
        }
      };
      xhr.send(loadNewsAjaxUrl);
    });
  }

});
